export default __webpack_public_path__ + "static/media/1978.7b030351.png";